import { createInitialFormData } from "@/application/mappers/investments/investmentFormMapper";
import type { InvestmentState } from "@/domain/investment/types";
import { getDefaultInvestmentPaymentDeadline } from "@/application/mappers/investments/investmentContractMapper";

export const investmentFormDefaults = (state: InvestmentState) =>
  createInitialFormData(null, null, state);

export const defaultInvestmentPaymentDeadline = () =>
  new Date(getDefaultInvestmentPaymentDeadline() ?? "");
